"use client";

import React, { useState, useEffect } from "react";
import { Scale, ShieldAlert, CheckCircle2 } from "lucide-react";

export default function BciDisclaimerModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const acknowledged = sessionStorage.getItem("bci_disclaimer_acknowledged");
    if (!acknowledged) {
      setIsOpen(true);
    }
  }, []);

  const handleAcknowledge = () => {
    sessionStorage.setItem("bci_disclaimer_acknowledged", "true");
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md animate-fade-in">
      <div className="relative w-full max-w-xl p-6 sm:p-8 rounded-2xl bg-slate-900 border border-amber-500/30 shadow-2xl text-slate-200">
        <div className="flex items-center gap-3 pb-4 border-b border-slate-800">
          <div className="p-2.5 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400">
            <Scale className="w-6 h-6" />
          </div>
          <div>
            <h3 className="text-base sm:text-lg font-serif font-bold text-white tracking-wide">
              Bar Council of India Disclaimer
            </h3>
            <p className="text-[11px] text-amber-400/90 font-medium">
              Rule 36 Compliance • Professional Ethics Acknowledgment
            </p>
          </div>
        </div>

        <div className="mt-4 space-y-3 text-xs leading-relaxed text-slate-300 max-h-[50vh] overflow-y-auto pr-1">
          <p>
            As per the rules of the <strong>Bar Council of India (BCI)</strong>, advocates and law practices are strictly prohibited from soliciting work, advertising services, or publicizing past case outcomes and client testimonials.
          </p>
          <div className="p-3 rounded-xl bg-slate-800/60 border border-slate-700/60 space-y-2 text-[11px]">
            <p className="font-semibold text-white">By accessing this demonstration portal, you explicitly acknowledge and confirm:</p>
            <ul className="list-disc list-inside space-y-1 text-slate-400">
              <li>You are seeking information regarding LexJuris Associates entirely of your own volition.</li>
              <li>There has been no advertisement, personal communication, solicitation, invitation, or inducement of any sort by the firm or its partners.</li>
              <li>The information provided herein is solely for informational and legal tech demonstration purposes.</li>
              <li>No advocate-client relationship is created solely by visiting this website or submitting preliminary evaluation inquiries.</li>
            </ul>
          </div>
          <div className="flex items-start gap-2 p-2.5 rounded-lg bg-amber-500/5 border border-amber-500/20 text-[11px] text-amber-300">
            <ShieldAlert className="w-4 h-4 shrink-0 mt-0.5" />
            <span>
              <strong>Demonstration Sandbox Notice:</strong> This portal showcases Johnson Softwares' custom Legal Practice Management CRM software suite. Do not submit sensitive real-world evidentiary data.
            </span>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-[11px] text-slate-500 italic">
            LexJuris Associates & Partners • New Delhi
          </span>
          <button
            type="button"
            onClick={handleAcknowledge}
            className="w-full sm:w-auto px-5 py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-bold text-xs shadow-lg transition-all flex items-center justify-center gap-2"
          >
            <CheckCircle2 className="w-4 h-4" />
            <span>I Acknowledge & Agree</span>
          </button>
        </div>
      </div>
    </div>
  );
}
